/**
 * @Author: 仙道
 * @Date: 2022-07-11 23:10:03
 * @LastEditTime: 2022-08-04 11:37:11
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/mixins/DragTableMixin.js
 **/
import Sortable from "sortablejs";
import { httpAction } from '@/api/manage'

export const DragTableModelMixin = {


  // 定义属性
  data () {
    return {
      // listPagination: {
      //   pageSize: 50,
      //   pageSizeOptions: ['50', '100', '200', '300']
      // },
      // pageSizeOptions: ['50', '100', '200', '300'],
      DragTableloading: false,
      // isorter: {
      //   column: 'sort',
      //   order: 'ascend'
      // },
    }
  },
  // 计算属性，会监听依赖属性值随之变化

  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (!this.DragTableloading) {
      this.$nextTick(() => {
        this.initSortable();
      })
    }
    //

  },
  // 方法集合
  methods: {
    initSortable () {

      this.DragTableloading = true

      const mytb = document.querySelector("tbody");
      const _this = this;
      new Sortable(mytb, {
        handle: ".ant-table-row",
        animation: 150,
        ghostClass: "blue-background-class",
        chosenClass: "sortable-chosen",  // 被选中项的css 类名
        //  handle: '.drag-btn',
        sort: true,
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.dataSource.splice(oldIndex, 1)[0];
          _this.dataSource.splice(newIndex, 0, currRow);
          //默认给上序号
          _this.model.iotModelPointsGroupMenberList = _this.dataSource.map((item, index) =>{Object.assign(item,{
                orderNo : index
            });
            return item;
          })
          let formData = Object.assign(_this.model);
          if (_this.url.sort) {
            httpAction(_this.url.edit, formData, 'put').then(res => {
              if (res.success) {
                _this.$message.success(res.message)
              } else {
                _this.$message.error(res.message)
              }
            })
          }
          // message.success(
          //   "排序完成！！！！位置从" + oldIndex + "移动到" + newIndex
          // );
        },
      });
    },


    rowClick: function (record, index) {
      return {
        on: {
          click: (event) => {
            console.log(record, index, event, "666");
          },

          dblclick: () => {
            console.log('双击了我')
          },

          // ...
        }
      }
    },
  }
}
